import { useParams } from "react-router-dom"

import { API_MODULE_HORIZONTAL_SIGNING, HorizontalSigningCampaignLayer } from "@l2r-front/l2r-app-city"
import { useCampaign } from "@l2r-front/l2r-shared-campaign"

import { useCampaignStateContext } from "../../contexts/CampaignContext"

export function CampaignLayer() {

    const { campaignId } = useParams()
    const { campaignFilters } = useCampaignStateContext()

    const { data: campaign } = useCampaign(campaignId)

    if (!campaign) {
        return null
    }

    switch (campaign.campaign_type) {
        case API_MODULE_HORIZONTAL_SIGNING:
            return <HorizontalSigningCampaignLayer campaignId={campaign.uuid} campaignFilters={campaignFilters} />
        default:
            return null
    }
}
